const dayInMilliSeconds = 24 * 60 * 60 * 1000

export default class DateUtils {
  static getDaysAgoInSeconds(days: number) {
    const startTimeInMilliseconds = new Date().getTime() - days * dayInMilliSeconds
    const startTimeInSeconds = Math.floor(startTimeInMilliseconds / 1000)
    return startTimeInSeconds
  }
}
